
    import './styles.scoped.css';
    export default {
  "segment": "awsui_segment_8cbea_19w97_17",
  "full-width": "awsui_full-width_8cbea_19w97_44",
  "refresh": "awsui_refresh_8cbea_19w97_47",
  "disabled": "awsui_disabled_8cbea_19w97_53",
  "selected": "awsui_selected_8cbea_19w97_110",
  "icon": "awsui_icon_8cbea_19w97_120",
  "with-text": "awsui_with-text_8cbea_19w97_124",
  "with-no-text": "awsui_with-no-text_8cbea_19w97_130",
  "root": "awsui_root_8cbea_19w97_135",
  "segment-part": "awsui_segment-part_8cbea_19w97_167",
  "grouped": "awsui_grouped_8cbea_19w97_188",
  "grouped-only": "awsui_grouped-only_8cbea_19w97_188",
  "grouped-vertical": "awsui_grouped-vertical_8cbea_19w97_192",
  "grouped-horizontal-first": "awsui_grouped-horizontal-first_8cbea_19w97_203",
  "grouped-horizontal-middle": "awsui_grouped-horizontal-middle_8cbea_19w97_207",
  "grouped-horizontal-last": "awsui_grouped-horizontal-last_8cbea_19w97_213",
  "grouped-vertical-first": "awsui_grouped-vertical-first_8cbea_19w97_217",
  "grouped-vertical-middle": "awsui_grouped-vertical-middle_8cbea_19w97_221",
  "grouped-vertical-last": "awsui_grouped-vertical-last_8cbea_19w97_227",
  "select": "awsui_select_8cbea_19w97_110",
  "segment-count-2": "awsui_segment-count-2_8cbea_19w97_244",
  "segment-count-3": "awsui_segment-count-3_8cbea_19w97_251",
  "segment-count-4": "awsui_segment-count-4_8cbea_19w97_258",
  "segment-count-5": "awsui_segment-count-5_8cbea_19w97_265",
  "segment-count-6": "awsui_segment-count-6_8cbea_19w97_272",
  "disabled-reason-tooltip": "awsui_disabled-reason-tooltip_8cbea_19w97_279"
};
  